import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { JCADashboardPage, JCADetailPage } from '../components'

export const JCARouter = () => {
  const permissions = useSelector((state) => state.global.permissions)

  return (
    <Routes>
      <Route path="/" element={<JCADashboardPage />} />
      {permissions.ver_detalle_jca ? <Route path=":jcaId" element={<JCADetailPage />} /> : null}
      <Route path="*" element={<Navigate to="/jca" />} />
    </Routes>
  )
}
